import { LAYOUT_HEIGHT } from 'state/constants';

export const boxStyles = {
    height: LAYOUT_HEIGHT,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    borderRadius: 1,
    border: "1px solid",
    borderColor: "neutral.deep",
    backgroundColor: "background.default",
};
